var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-volume1 lucide-volume-1 w-5 h-5",
    "aria-hidden": "true",
    "data-fg-out832": ":2385.58:/components/PerformerProfile.tsx:2424:33:128225:31:e:Volume1::::::DWM3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9a5 5 0 0 1 0 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLow);
export default __webpack_public_path__ + "static/media/volume-low.4c126427ffd55f787c0d77a8d7e98735.svg";
export { ForwardRef as ReactComponent };